var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mbs-search-select-items',{attrs:{"color":"blue","bar_type":"warehouse","show_toolbar":true,"show_table":false}}),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }